<template>
  <div class="sf-page"
       v-if="supplier != null">
    <div class="sf-container sf-container--narrow sf-registration">
      <supplier-registration-stepper v-bind:supplier="supplier"
                                     v-bind:event="event"
                                     v-on:send="updateSupplier" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import TopHeader from '@/components/common/TopHeader'
  import SupplierRegistrationStepper from '@/components/registration/SupplierRegistrationStepper'

  export default {
    async beforeRouteUpdate(to, from, next) {
      const invitationCode = to.params.invitationCode

      await this.get(invitationCode)

      next()
    },
    components: {
      SupplierRegistrationStepper,
      TopHeader
    },
    computed: {
      ...mapGetters({
        event: 'event'
      })
    },
    async created() {
      const invitationCode = this.$route.params.invitationCode

      await this.get(invitationCode)
    },
    data: () => ({
      invitationCode: null,
      supplier: null
    }),
    methods: {
      async get(invitationCode) {
        this.invitationCode = invitationCode

        await this.$store.dispatch('loadSupplierByInvitationCode', { invitationCode })

        const supplier = this.$store.getters.supplierByInvitationCode(invitationCode)

        if (supplier == null || supplier.state === 'accepted' || supplier.state === 'declined') {
          this.$router.push({ name: 'home' })
        }

        this.supplier = Object.assign({}, supplier)
      },
      async updateSupplier({ supplier, form }) {
        supplier.state = form.attendance ? 'accepted' : 'declined'

        await this.$store.dispatch('updateSupplier', { supplier })

        /*if (form.attendance) {
          await this.$store.dispatch('sendSupplierMarketingInformation', { id: supplier.id })
        }*/
      }
    },
    name: 'SupplierRegistration'
  }
</script>

<style scoped>
  .sf-registration {
    padding-top: 32px;
  }

  @media (max-width: 599px) {
    .sf-registration {
      padding-top: 16px;
    }
  }
</style>
